import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTokenList } from '../../hooks/queries/useTokenList'
import Main from '../../components/templates/MainContent'
import SearchContainer from '../../components/organisms/SearchContainer'
import Search from '../Search'
import * as S from './styles'
import ContentsTitle from '../../components/molecules/ContentsTitle'
import SymbolCard from '../../components/molecules/SymbolCard'
import PageLoading from '../../components/organisms/PageLoading'
import { PAGE_SIZE } from '../../constants'

function TokenList() {
  const { tokens = [], totalToken = 0, isLoading } = useTokenList(1, PAGE_SIZE)

  const navigate = useNavigate()
  const onClickToken = (address: string) => {
    navigate(`/token/${address}`)
  }
  return (
    <Main>
      <SearchContainer>
        <Search />
      </SearchContainer>
      <S.TitleContainer>
        <ContentsTitle
          title="Token Tracker"
          subTitle={
            <p>
              A total of <S.TranNum>{totalToken}</S.TranNum> token contracts
            </p>
          }
        />
      </S.TitleContainer>
      <S.SymbolWrapper>
        {tokens.map((token, index) => (
          <SymbolCard
            key={index}
            symbolImg={token.imageUrl}
            name={token.name}
            value={token.symbol}
            onClick={() => onClickToken(token.address)}
          />
        ))}
      </S.SymbolWrapper>
      <PageLoading loading={isLoading} />
    </Main>
  )
}

export default TokenList
